import {
  Button,
  DialogForm,
  Form,
  FormDescription,
  Label,
} from '@ais-ui/ui-core';
import React from 'react';

import { cn } from '@ais-ui/utils';
import { MutateRouteForm } from './MutateRouteForm';
import { useLocalization } from '@ais-ui/locale-management';
import { PiBoat } from 'react-icons/pi';
import { ShipInfo, TargetInfoType } from '@ais-ui/websockets';
import { useAISMapContext } from '../../Map/AISMapContext';
import { useRoutes } from '../RoutesContext';

interface RouteDialogProps {
  mutateType: 'edit' | 'create';
}

export const RouteDialog = ({ mutateType }: RouteDialogProps) => {
  const { messages } = useLocalization();
  const dialogTitle =
    mutateType === 'create'
      ? messages.routesCreateTitle
      : messages.routesEditTitle;

  const { showDialog, setShowDialog, isSubmitting, form, onCreateRoute } =
    useRoutes();

  const {
    setShowChooseTargetPanel,
    onChooseTarget,
    onRejectTarget,
    setChooseTargetTypes,
  } = useAISMapContext();

  const handleOpenChange = (isOpen: boolean) => {
    setShowDialog(isOpen);
  };

  const onSelectShipOnMap = () => {
    setShowDialog(false);
    setShowChooseTargetPanel(true);
    setChooseTargetTypes(['ship']);

    onChooseTarget.current = (target: TargetInfoType) => {
      const ship = target as ShipInfo;
      form.setValue('sourceShip.name', ship.name);
      form.setValue('sourceShip.imo', ship.imo);
      form.setValue('sourceShip.type', ship.shipType);
      form.setValue('sourceShip.mmsi', ship.mmsi);
      form.setValue('sourceShip.callSign', ship.callSign);
      setShowDialog(true);
      setShowChooseTargetPanel(false);
    };

    onRejectTarget.current = () => {
      setShowDialog(true);
      setShowChooseTargetPanel(false);
    };
  };

  return (
    <Form {...form}>
      <DialogForm
        showDialog={showDialog}
        onOpenChange={handleOpenChange}
        title={dialogTitle}
        buttonId="submit-route-button"
        buttonText={
          isSubmitting ? messages.genericSubmitting : messages.genericSubmit
        }
        buttonDisabled={isSubmitting}
        buttonOnClick={form.handleSubmit(onCreateRoute)}
      >
        <div className="space-y-6">
          <div
            className={cn(
              'flex flex-row items-center justify-between border rounded-lg p-4'
            )}
          >
            <div className="space-y-0.5">
              <Label className="text-base">Select ship</Label>
              <FormDescription>Select ship on the map</FormDescription>
            </div>
            <Button variant="outline" size="icon" onClick={onSelectShipOnMap}>
              <PiBoat className="h-5 w-5" />
            </Button>
          </div>

          <MutateRouteForm form={form}></MutateRouteForm>
        </div>
      </DialogForm>
    </Form>
  );
};
